import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { ServerUrls } from '../../app/ServerUrls';
import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { ScheduleSubspaceName } from '../../app/state/SpaceInfo';
import { ScheduleSpaceProvider } from './ScheduleSpaceProvider';

// The properties here must match the strings in the Routes' path below
export interface ScheduleSpaceRouteParams {
  readonly id: string;
}
export interface ScheduleRouteComponentProps extends RouteComponentProps<ScheduleSpaceRouteParams> {}

export interface ScheduleSpaceRouterOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls | ServerUrls;
}

export type ScheduleSpaceRouterProps = ScheduleSpaceRouterOwnProps;

export class ScheduleSpaceRouter extends React.Component<ScheduleSpaceRouterProps> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.scheduleSubscriptionsPath(':id')} render={this.provider('subscriptions')}/>
        <Route exact path={this.props.urls.scheduleFlowsPath(':id')} render={this.provider('flows')}/>
        <Route exact path={this.props.urls.scheduleExtractRefreshesPath(':id')} render={this.provider('extractRefreshes')}/>
        <Route exact path={this.props.urls.scheduleDetailsPath(':id')} render={this.provider('details')}/>
        <Route exact path={this.props.urls.schedulePath(':id')} render={this.error}/>
        <Route render={this.error}/>
      </Switch>
    );
  }

  private error = (_props: RouteComponentProps): JSX.Element => {
    if (this.props.urls instanceof SpacesSiteUrls) {
      return <RouterError errorType={'default'} urls={this.props.urls}/>;
    } else {
      return <RouterError errorType={'server-default'} urls={undefined}/>;
    }
  }

  private provider = (subspaceName: ScheduleSubspaceName): (props: ScheduleRouteComponentProps) => JSX.Element => {
    return (routeProps: ScheduleRouteComponentProps): JSX.Element => {
      return <ScheduleSpaceProvider
        routeLocationPath={routeProps.location.pathname}
        routeLocationSearch={routeProps.location.search}
        siteName={this.props.siteName}
        scheduleId={routeProps.match.params.id}
        subspaceName={subspaceName}
        urls={this.props.urls}
      />;
    };
  }
}
